import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  v2Subdescription: {
    description: 'Subtitle of this section. Only appears when the user can create V2 API keys',
    defaultMessage: 'Integrate shipping into your custom applications and build delivery experiences using our APIs.',
    id: 'kd55dp',
  },
  keys: {
    description: 'Section title',
    defaultMessage: 'API Keys',
    id: 'MTKVct',
  },
  secureStorageText: {
    description: 'Text that appears after the section title',
    defaultMessage: 'You should never expose your API keys. <b>Please store it securely.</b>',
    id: 'Who5YX',
  },
  notAccountOwnerMessage: {
    description: 'Message explaining that API keys can only be generated by the account owner.',
    defaultMessage: '<b>API keys can only be generated by the account owner.</b> Contact your account owner for assistance.',
    id: 'mm4Tvn',
  },
  mfaModalTitle: {
    description: 'modal title that is shown to users when they must complete mfa to continue with the desired action',
    defaultMessage: 'Manage API Key Settings',
    id: 'TiFNxZ',
  },
});
